import { authHeaderTokenName } from 'src/constants'
import { localStoragesName } from 'src/models/enum/localStoragesName'

export const authHeader = () => {
  const token = sessionStorage.getItem(localStoragesName.token) || ''
  return token ? { Authorization: `${authHeaderTokenName} ${token}` } : {}
}
